import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { 
  Home, 
  Building2, 
  CreditCard, 
  Landmark,
  User,
  FileText, 
  Users2, Handshake, 
  FileSpreadsheet, 
  BarChart3, 
  MessageSquare, 
  Dumbbell,
  Activity,
  Cog,
  Wrench,
  Bot,
  ChevronLeft,
  ChevronRight,
  Menu,
  X,
  Sun,
  Moon,
  Euro, 
  TrendingUp,
  Map,
  Gem,
  Lightbulb,
  LogOut,
  Zap,
  Languages,
  Briefcase,
  Printer, PenLine,
  Vote,
  Eye, Box,
  Receipt,
  Search,
  CheckCircle,
  History,
  Shield,
} from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';
import { useAuth } from '../../contexts/AuthContext';

const SidebarMaster = ({ isCollapsed, setIsCollapsed, isMobile, setIsMobileMenuOpen }) => {
  const { theme, toggleTheme } = useTheme();
  const { hasRole, hasTag, signOut } = useAuth();
  const { t, i18n } = useTranslation('sidebar');


  const allNavigationItems = [
    // Dashboard (allein)
    { icon: Home, label: t('navigation.dashboard'), path: '/', category: null, roles: ['SUPER_ADMIN', 'ADMIN', 'CLIENT', 'PILOT_CLIENT'] },
    
    // VERWALTUNG
    { icon: User, label: t('navigation.owners'), path: '/owners', category: 'VERWALTUNG', roles: ['SUPER_ADMIN', 'ADMIN', 'CLIENT'] },
    { icon: Vote, label: t('navigation.hoa-management'), path: '/hoa-management', category: 'VERWALTUNG', roles: ['SUPER_ADMIN'] },
    { icon: Building2, label: t('navigation.my-properties'), path: '/properties', category: 'VERWALTUNG', roles: ['SUPER_ADMIN', 'ADMIN', 'CLIENT', 'PILOT_CLIENT'] },
    { icon: Handshake, label: t('navigation.my-tenants'), path: '/tenants', category: 'VERWALTUNG', roles: ['SUPER_ADMIN', 'ADMIN', 'CLIENT', 'PILOT_CLIENT'] },
    { icon: FileSpreadsheet, label: t('navigation.documents'), path: '/documents', category: 'VERWALTUNG', roles: ['SUPER_ADMIN', 'PILOT_CLIENT'] },
    { icon: Euro, label: t('navigation.management'), path: '/bewirtschaftung', category: 'VERWALTUNG', roles: ['SUPER_ADMIN', 'ADMIN', 'CLIENT', 'PILOT_CLIENT'] },
    { icon: Printer, label: t('navigation.contract-management'), path: '/contract-management', category: 'VERWALTUNG', roles: ['SUPER_ADMIN', 'ADMIN', 'CLIENT'] },
    { icon: Zap, label: 'Stromvertrags-Hub', path: '/energy-contract-hub', category: 'VERWALTUNG', roles: ['SUPER_ADMIN', 'ADMIN', 'CLIENT', 'PILOT_CLIENT'] },
    { icon: PenLine, label: 'Signaturen', path: '/signaturen', category: 'VERWALTUNG', roles: ['SUPER_ADMIN'] },
    
    // FINANZEN
    { icon: Landmark, label: t('navigation.banking'), path: '/banking', category: 'FINANZEN', roles: ['SUPER_ADMIN'] },
    { icon: CreditCard, label: t('navigation.financing'), path: '/finanzierungen', category: 'FINANZEN', roles: ['SUPER_ADMIN', 'ADMIN', 'CLIENT'] },
    { icon: Receipt, label: "Steuern & Buchhaltung", path: "/steuern", category: "FINANZEN", roles: ["SUPER_ADMIN"] },
    { icon: CheckCircle, label: "Mieteingangskontrolle", path: "/mieteingangskontrolle", category: "FINANZEN", roles: ["SUPER_ADMIN", "ADMIN", "CLIENT"] },
    { icon: History, label: "Miet- & NK-Historie", path: "/miet-nk-historie", category: "FINANZEN", roles: ["SUPER_ADMIN", "ADMIN", "CLIENT"] },
    { icon: Handshake, label: t('navigation.co-ownership'), path: '/shared-economy', category: 'FINANZEN', roles: ['SUPER_ADMIN'] },
    { icon: BarChart3, label: t('navigation.analytics'), path: '/analytics', category: 'FINANZEN', roles: ['SUPER_ADMIN', 'ADMIN', 'CLIENT'] },
    { icon: TrendingUp, label: t('navigation.rent-adjustments'), path: '/lease-adjustments', category: 'FINANZEN', roles: ['SUPER_ADMIN'] },
    { icon: Gem, label: t('navigation.investment-cockpit'), path: '/investment-cockpit', category: 'FINANZEN', roles: ['SUPER_ADMIN'] },
    { icon: FileText, label: "NK-Abrechnung", path: "/utility-billing", category: "FINANZEN", roles: ["SUPER_ADMIN"] },
    
    // TOOLS
    { icon: Bot, label: t('navigation.clara-ai'), path: '/clara-ki', category: 'TOOLS', roles: ['SUPER_ADMIN', 'ADMIN', 'CLIENT', 'PILOT_CLIENT'] },
    { icon: Search, label: 'Clara AI Search', path: '/clara-ai-search', category: 'TOOLS', roles: ['SUPER_ADMIN'] },
    { icon: Zap, label: t('navigation.clara-iot'), path: '/clara-iot', category: 'TOOLS', roles: ['SUPER_ADMIN'] },
    { icon: Eye, label: "Property Visualizer", path: '/property-visualizer', category: 'TOOLS', roles: ['SUPER_ADMIN'] },
    { icon: Box, label: "Grundriss zu 3D", path: "/grundriss-editor", category: "TOOLS", roles: ["SUPER_ADMIN"] },
    { icon: Map, label: t('navigation.marketplace'), path: '/marketplace', category: 'TOOLS', roles: ['SUPER_ADMIN'] },
    { icon: Activity, label: t('navigation.activities'), path: '/activities', category: 'TOOLS', roles: ['SUPER_ADMIN'] },
    { icon: MessageSquare, label: t('navigation.communication'), path: '/communications', category: 'TOOLS', roles: ['SUPER_ADMIN', 'PILOT_CLIENT'] },
    { icon: Wrench, label: t('navigation.maintenance'), path: '/maintenance', category: 'TOOLS', roles: ['SUPER_ADMIN'] },
    { icon: Shield, label: 'Compliance Hub', path: '/compliance-hub', category: 'TOOLS', roles: ['SUPER_ADMIN'] },
    { icon: Lightbulb, label: t('navigation.tenant-portal'), path: '/tenant-portal', category: 'TOOLS', roles: ['SUPER_ADMIN'] },
    
    // EINZELNE SEITEN
    { icon: Map, label: t('navigation.regional-insights'), path: '/regionale-insights', category: null, roles: ['SUPER_ADMIN'] },
    
    // VITAL CENTER
    { icon: Dumbbell, label: t('navigation.vital-center'), path: '/vital-center', category: null, roles: ['SUPER_ADMIN'] },
    
    // EINSTELLUNGEN
    { icon: Cog, label: t('navigation.settings'), path: '/settings', category: null, roles: ['SUPER_ADMIN'] }
  ];

  // Filter navigation items based on user role
  const navigationItems = allNavigationItems.filter(item => {
    if (hasTag('isSuperAdmin')) {
      return true;
    }
    return item.roles.some(role => hasRole(role));
  });

  // T-2: Toggle-Semantik — Button zeigt Ziel-Theme, nicht aktuelles Theme
  // Im Dark Mode → Button zeigt "Light Mode" (Sonne), Aktion: zu Light wechseln
  // Im Light Mode → Button zeigt "Dark Mode" (Mond), Aktion: zu Dark wechseln
  const getThemeInfo = () => {
    if (theme === 'dark') {
      return { icon: Sun, text: 'Light Mode', ariaLabel: 'Zu Light Mode wechseln' };
    }
    return { icon: Moon, text: 'Dark Mode', ariaLabel: 'Zu Dark Mode wechseln' };
  };

  const themeInfo = getThemeInfo();
  const ThemeIcon = themeInfo.icon;

  // T-4 + Slate-Palette: Hybrid-Block entfernt, Dark auf Slate migriert
  const getThemeClasses = () => {
    if (theme === 'light') {
      return {
        background: 'bg-white border-gray-200',
        text: 'text-gray-900',
        textSecondary: 'text-gray-600',
        hover: 'hover:bg-gray-100',
        active: 'bg-blue-100 text-blue-700',
        border: 'border-gray-200',
        tooltip: 'bg-gray-900 text-white'
      };
    }
    // dark (default) — vollständig auf Slate-Palette
    return {
      background: 'bg-black border-slate-800',
      text: 'text-slate-100',
      textSecondary: 'text-slate-300',
      hover: 'hover:bg-slate-800',
      active: 'bg-blue-800/50 text-blue-200',
      border: 'border-slate-700',
      tooltip: 'bg-slate-100 text-slate-900'
    };
  };

  const themeClasses = getThemeClasses();

  return (
    <>
      {/* Mobile Menu Overlay */}
      {isMobile && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-40 md:hidden"
          onClick={() => setIsMobileMenuOpen(false)}
        />
      )}

      {/* Sidebar */}
      <div className={`
        fixed left-0 top-0 h-screen hidden md:flex flex-col z-50 transition-all duration-300 border-r shadow-[2px_0_8px_rgba(0,0,0,0.3)]
        ${themeClasses.background} ${themeClasses.border}
        ${isCollapsed ? 'w-16' : 'w-64'}
      `}>
        {/* Header */}
        <div className={`flex items-center justify-between p-4 border-b ${themeClasses.border}`}>
          {!isCollapsed && (
            <div className="flex items-center space-x-2">
              <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-sm">C</span>
              </div>
              <span className={`font-bold text-lg ${themeClasses.text}`}>Clara360</span>
            </div>
          )}
          
          <button
            onClick={() => setIsCollapsed(!isCollapsed)}
            className={`
              p-2 rounded-lg transition-colors
              ${themeClasses.textSecondary} ${themeClasses.hover}
              ${isCollapsed ? 'mx-auto' : ''}
            `}
          >
            {isCollapsed ? (
              <ChevronRight className="w-4 h-4" />
            ) : (
              <ChevronLeft className="w-4 h-4" />
            )}
          </button>
        </div>

        {/* Navigation */}
        <nav className="flex-1 overflow-y-auto scrollbar-hide p-2">
          <div className="space-y-1">
            {navigationItems.map((item, index) => {
              const Icon = item.icon;
              const showCategoryHeader = item.category && 
                (index === 0 || navigationItems[index - 1].category !== item.category);
              
              return (
                <div key={item.path}>
                  {/* Category Header */}
                  {showCategoryHeader && !isCollapsed && (
                    <div className={`px-3 py-2 text-xs font-semibold uppercase tracking-wider ${themeClasses.textSecondary} opacity-60`}>
                      {item.category}
                    </div>
                  )}
                  
                  {/* Navigation Item */}
                  <div className="relative">
                    <NavLink title=""
                      to={item.path}
                      className={({ isActive }) => `
                        group flex items-center transition-all duration-200 rounded-lg
                        ${isActive 
                          ? themeClasses.active + " border"
                          : themeClasses.textSecondary + " " + themeClasses.hover
                        }
                        ${isCollapsed 
                          ? "justify-center p-3 w-12 h-12 mx-auto" 
                          : "justify-start space-x-3 px-3 py-2.5"
                        }
                      `}
                    >
                      <Icon className={`
                        ${isCollapsed ? "w-5 h-5" : "w-5 h-5"}
                        flex-shrink-0
                      `} />
                      {!isCollapsed && (
                        <span className="font-medium text-sm truncate">
                          {item.label}
                        </span>
                      )}
                    </NavLink>
                    
                    {/* Tooltip for collapsed state */}
                    {isCollapsed && (
                      <div className={`
                        absolute left-full ml-2 px-3 py-2 rounded-lg text-sm font-medium
                        opacity-0 invisible group-hover:opacity-100 group-hover:visible
                        transition-all duration-200 pointer-events-none z-50
                        ${themeClasses.tooltip}
                        whitespace-nowrap shadow-lg
                      `}
                      style={{
                        top: "50%",
                        transform: "translateY(-50%)"
                      }}>
                        {item.label}
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </nav>

        {/* Theme Toggle & Logout */}
        <div className={`p-4 border-t ${themeClasses.border}`}>
          {isCollapsed ? (
            // Collapsed: Stack vertically
            <div className="space-y-2">
              <button
                onClick={toggleTheme}
                aria-label={themeInfo.ariaLabel}
                title={themeInfo.ariaLabel}
                className="w-full flex items-center justify-center p-3 rounded-lg transition-all duration-200 text-blue-400 hover:text-blue-300 hover:bg-blue-500/10"
              >
                <ThemeIcon className="w-5 h-5 flex-shrink-0" />
              </button>
              <button
                onClick={() => signOut()}
                className="w-full flex items-center justify-center p-3 rounded-lg transition-all duration-200 text-red-400 hover:text-red-300 hover:bg-red-500/10"
              >
                <LogOut className="w-5 h-5 flex-shrink-0" />
              </button>
            </div>
          ) : (
            // Expanded: Side by side
            <div className="grid grid-cols-2 gap-2">
              <button
                onClick={toggleTheme}
                aria-label={themeInfo.ariaLabel}
                title={themeInfo.ariaLabel}
                className="flex items-center justify-center space-x-2 px-3 py-2.5 rounded-lg transition-all duration-200 text-blue-400 hover:text-blue-300 hover:bg-blue-500/10"
              >
                <ThemeIcon className="w-5 h-5 flex-shrink-0" />
                <span className="font-medium text-xs truncate">
                  {themeInfo.text}
                </span>
              </button>
              <button
                onClick={() => signOut()}
                className="flex items-center justify-center space-x-2 px-3 py-2.5 rounded-lg transition-all duration-200 text-red-400 hover:text-red-300 hover:bg-red-500/10"
              >
                <LogOut className="w-5 h-5 flex-shrink-0" />
                <span className="font-medium text-xs truncate">
                  Logout
                </span>
              </button>
            </div>
          )}
        </div>
      </div>

      {/* Mobile Sidebar */}
      <div className={`
        fixed inset-y-0 left-0 z-50 w-64 transform transition-transform duration-300 ease-in-out md:hidden
        ${isMobile ? 'translate-x-0' : '-translate-x-full'}
        ${themeClasses.background} ${themeClasses.border}
      `}>
        {/* Mobile Header */}
        <div className={`flex items-center justify-between p-4 border-b ${themeClasses.border}`}>
          <div className="flex items-center space-x-2">
            <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center">
              <span className="text-white font-bold text-sm">C</span>
            </div>
            <span className={`font-bold text-lg ${themeClasses.text}`}>Clara360</span>
          </div>
          
          <button
            onClick={() => setIsMobileMenuOpen(false)}
            className={`
              p-2 rounded-lg transition-colors
              ${themeClasses.textSecondary} ${themeClasses.hover}
            `}
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Mobile Navigation */}
        <nav className="flex-1 overflow-y-auto scrollbar-hide p-2">
          <div className="space-y-1">
            {navigationItems.map((item) => {
              const Icon = item.icon;
              return (
                <NavLink title=""
                  key={item.path}
                  to={item.path}
                  onClick={() => setIsMobileMenuOpen(false)}
                  className={({ isActive }) => `
                    flex items-center space-x-3 px-3 py-2.5 rounded-lg transition-all duration-200
                    ${isActive 
                      ? themeClasses.active + ' border'
                      : themeClasses.textSecondary + ' ' + themeClasses.hover
                    }
                  `}
                >
                  <Icon className="w-5 h-5 flex-shrink-0" />
                  <span className="font-medium text-sm truncate">
                    {item.label}
                  </span>
                </NavLink>
              );
            })}
          </div>
        </nav>

        {/* Mobile Theme Toggle & Logout */}
        <div className={`p-4 border-t ${themeClasses.border}`}>
          <div className="grid grid-cols-2 gap-2">
            <button
              onClick={toggleTheme}
              aria-label={themeInfo.ariaLabel}
              title={themeInfo.ariaLabel}
              className={`
                flex items-center justify-center space-x-2 px-3 py-2.5 rounded-lg transition-colors
                ${themeClasses.textSecondary} ${themeClasses.hover}
              `}
            >
              <ThemeIcon className="w-5 h-5 flex-shrink-0" />
              <span className="font-medium text-xs truncate">
                {themeInfo.text}
              </span>
            </button>
            <button
              onClick={() => signOut()}
              className="flex items-center justify-center space-x-2 px-3 py-2.5 rounded-lg transition-colors text-red-400 hover:text-red-300 hover:bg-red-500/10"
            >
              <LogOut className="w-5 h-5 flex-shrink-0" />
              <span className="font-medium text-xs truncate">
                Logout
              </span>
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default SidebarMaster;
